import { render } from "./IconExternalTransfer.vue?vue&type=template&id=4a21c774"
import script from "./IconExternalTransfer.vue?vue&type=script&lang=js"
export * from "./IconExternalTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconExternalTransfer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a21c774"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a21c774', __exports__)) {
    api.reload('4a21c774', __exports__)
  }
  
  module.hot.accept("./IconExternalTransfer.vue?vue&type=template&id=4a21c774", () => {
    api.rerender('4a21c774', render)
  })

}


export default __exports__